import type { AuthUser, UserRole } from '@/types/auth.types';

export type LanguageProfileField =
  | 'spokenLanguages'
  | 'contributionLanguages'
  | 'moderationLanguages';

export const getRequiredLanguageFields = (
  role?: UserRole,
): LanguageProfileField[] => {
  if (role === 'moderator') {
    return ['spokenLanguages', 'moderationLanguages'];
  }
  if (role === 'user' || role === 'collector') {
    return ['spokenLanguages', 'contributionLanguages'];
  }
  return ['spokenLanguages'];
};

export const isLanguageProfileIncomplete = (
  user?: Partial<AuthUser> | null,
): boolean => {
  if (!user) return false;
  return getRequiredLanguageFields(user.role).some(
    (field) => !Array.isArray(user[field]) || user[field]!.length === 0,
  );
};
